// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"lN-z","carouselContainer":"mN-z"};